import { render, staticRenderFns } from "./isUnbinding.vue?vue&type=template&id=19ced36a&"
import script from "./isUnbinding.vue?vue&type=script&lang=js&"
export * from "./isUnbinding.vue?vue&type=script&lang=js&"
import style0 from "./isUnbinding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports